import { useUserStore } from '@/config/store/userStore'

/**
 * Electronic signature is an option of the subscription, re-billed per signed document: without it
 * the features stay visible but no document can be sent to sign (the API refuses it too).
 */
export const hasESignatureOption = (user = useUserStore().user) => !!user?.firm?.eSignature

/** The documentation page explaining the option, on the BestConsultant website, in the user's language. */
export const eSignatureDocUrl = (locale: string) => {
  const lang = String(locale || '').toLowerCase().startsWith('en') ? 'en' : 'fr'
  return `https://bc.direct/${lang}/docs/hrbase/electronic-signature`
}
